"use strict";
import { Auth } from "aws-amplify";
import axios from "axios";
import imsrconfig from "../imsr-exports.js";

export class ImsrApi {
  constructor() {
    this.baseurl = imsrconfig.endpoint + imsrconfig.stage;
  }

  async doApi(method, api, params) {
    try {
      let res = {};
      const { idToken } = await Auth.currentSession();
      const headers = {
        "Content-Type": "application/json",
        Authorization: idToken.jwtToken,
      };

      switch (method) {
        case "get":
          res = await axios.get(this.baseurl + api, {
            params: params,
            headers: headers,
          });
          break;
        case "delete":
          res = await axios.delete(this.baseurl + api, {
            params: params,
            headers: headers,
          });
          break;
        case "post":
          res = await axios.post(this.baseurl + api, params, {
            headers: headers,
          });
          break;
        case "put":
          res = await axios.put(this.baseurl + api, params, {
            headers: headers,
          });
          break;
      }
      return res.data.data;
    } catch (e) {
      if (imsrconfig.stage == "main") {
        console.log("imsrGetApi:", e.response); // eslint-disable-line no-console
      }
      if (axios.isAxiosError(e)) {
        if (e.response.status !== undefined && e.response.data !== undefined) {
          throw { status: e.response.status, message: e.response.data.message };
        } else throw { status: 500, message: "System Error" };
      } else {
        throw { status: 500, message: "System Error" };
      }
    }
  }

  async doTokenApi(api, params) {
    try {
      let res = {};
      const { idToken, accessToken } = await Auth.currentSession();
      const headers = {
        "Content-Type": "application/json",
        Authorization: idToken.jwtToken,
      };
      params.accessToken = accessToken.jwtToken;
      res = await axios.post(this.baseurl + api, params, {
        headers: headers,
      });
      return res.data.data;
    } catch (e) {
      if (imsrconfig.stage == "main") {
        console.log("imsrGetApi:", e.response); // eslint-disable-line no-console
      }
      if (axios.isAxiosError(e)) {
        if (e.response.status !== undefined && e.response.data !== undefined) {
          throw { status: e.response.status, message: e.response.data.message };
        } else throw { status: 500, message: "System Error" };
      } else {
        throw { status: 500, message: "System Error" };
      }
    }
  }
}

export default ImsrApi;
